import React, { useEffect, useRef } from 'react'
import { WidgetInstance } from 'friendly-challenge'
import { GoogleReCaptchaProvider, GoogleReCaptcha } from 'react-google-recaptcha-v3'

export default function Captcha({
  captchaType, captchaSiteKey, triggerResetCaptcha, setTriggerResetCaptcha,
  setCaptchaToken
}) {
  const container = useRef()
  const widget = useRef()

  useEffect(() => {
    if (captchaType === 'friendly_captcha') {
      if (!widget.current && container.current) {
        widget.current = new WidgetInstance(container.current, {
          startMode: 'auto',
          doneCallback: token => setCaptchaToken(token),
          errorCallback: () => {}
        })
      }
    }

    return () => {
      if (captchaType === 'friendly_captcha' && widget.current != undefined) widget.current.destroy()
    }
  }, [container])

  useEffect( () => {
    if (triggerResetCaptcha) {
      if (captchaType === 'friendly_captcha') {
        widget.current.reset()
      }
      setTriggerResetCaptcha(false)
    }
  }, [triggerResetCaptcha])

  return (
    <>
      { captchaType === 'friendly_captcha' &&
        <div
          ref={ container }
          className='frc-captcha'
          data-sitekey={ captchaSiteKey }
          data-lang={ Cas.locale }
          style={{ marginBottom: 30 }}
        />
      }

      { captchaType === 'reCAPTCHA' &&
        <GoogleReCaptchaProvider
          reCaptchaKey={ captchaSiteKey }
          language={ Cas.locale }
        >
          <GoogleReCaptcha onVerify={ token => setCaptchaToken(token) }/>
        </GoogleReCaptchaProvider>
      }
    </>
  )
}
